import type { Schema } from './schema-meta.ts';
import { registerSchema } from './generic-codec.ts';

const CATEGORY_SCHEMAS_INTERNAL: Record<string, Schema> = {};

export function registerCategorySchema(categoryName: string, schema: Schema): void {
  CATEGORY_SCHEMAS_INTERNAL[categoryName] = schema;
  registerSchema(schema);
}

export const CATEGORY_SCHEMAS: Readonly<Record<string, Schema>> = CATEGORY_SCHEMAS_INTERNAL;

export function getCategorySchema(categoryName: string): Schema {
  const s = CATEGORY_SCHEMAS_INTERNAL[categoryName];
  if (!s) throw new Error(`no schema for category: ${categoryName}`);
  return s;
}

// (Phase B tasks add `import './schemas/...';` lines below as schemas are written.)
